// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/Width.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField, css } from '@sail/ui'; // TODO: width is currently still broken when not using `&&`

export const Width = () => <TextField label="Age" css={{
  width: css.value('42px')
}} />;